import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createAsyncThunkHelper } from "../../helper/helperFunctions";

export const getVatList = createAsyncThunk("vat-list-fetch", async (reqbody) => {

    console.log("reqbody 666", reqbody)

    let req_body = {};
    req_body = reqbody;
    // console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    // console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api3/getvatlist", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

////////////////////////////////// Delete Multiple Item form Table //////////////////////////////////
export const deletemultyple = createAsyncThunk("vat-list-delete", async (reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api3/deletemultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});

////////////////////////////////// Edit Single Item form Table //////////////////////////////////
export const vataddeditsingle = createAsyncThunk("vat-list-edit-single", async (reqbody) => {

    let req_body = {};
    req_body = reqbody;
    console.log("reqbody 666", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api3/vataddedit", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});

////////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
export const vataddeditmultiple = createAsyncThunk("vat-list-edit-multiple", async (reqbody) => {

    let req_body = {};
    req_body = reqbody;
    console.log("reqbody 666", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api3/vataddeditmultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});


const VatManagement = createSlice({
    name: 'vatmanagement',
    initialState: {
        loading: false,
        success: false,
        successmsg: null,
        editSuccess: false,
        deleteSuccess: false,
        vatList: [],
    },
    reducers: {
        setSuccessAfterSubmit(state, action) {
            state.success = false;
            state.editSuccess = false;
            state.deleteSuccess = false;
            state.successmsg = null;
        }
    },
    extraReducers: {
        /// For GEt Product List
        [getVatList.pending]: (state, action) => {
            state.loading = true;
            state.success = false;
        },
        [getVatList.fulfilled]: (state, action) => {
            console.log("action fetch 666", action)
            if (action.payload.status === 'success') {
                state.vatList = [...action.payload.results.res];
                state.successmsg = action.payload.status;
                state.loading = false;
                state.success = true;

            }
        },
        [getVatList.rejected]: (state, action) => {
            state.submitting = false;
            state.loading = false;
        },

        // closeModal(state, action) {
        //     delete state.openModal[action.payload.id];
        //     delete state.tempModalData[action.payload.id];
        // },
        //////////////////////////// Delete Multiple Item ///////////////////////////////
        [deletemultyple.pending]: (state, action) => {
            state.loading = true;
        },
        [deletemultyple.fulfilled]: (state, action) => {
            console.log("action delete 666", action)
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Deleted Successfully';
                // state.success = true;
                state.deleteSuccess = true;
            }
        },
        [deletemultyple.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },
        //////////////////////////// Edit Single Item ///////////////////////////////
        [vataddeditsingle.pending]: (state, action) => {
            state.loading = true;
        },
        [vataddeditsingle.fulfilled]: (state, action) => {
            console.log("action add 666", action)
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully'
                // state.success = true;
                state.editSuccess = true;
            }
        },
        [vataddeditsingle.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },
        //////////////////////////// Edit Multiple Item ///////////////////////////////
        [vataddeditmultiple.pending]: (state, action) => {
            state.loading = true;
        },
        [vataddeditmultiple.fulfilled]: (state, action) => {
            console.log("action update 666", action)
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully'
                // state.success = true;
                state.editSuccess = true;
            }
        },
        [vataddeditmultiple.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        }
    }
})

export const { setSuccessAfterSubmit } = VatManagement.actions;
export default VatManagement.reducer;